import React from 'react';
import OrderForm from './OrderForm';
import Products from './Products';

const Home = () => {
  return (
    <div className="bg-secondary-100 mt-2">
      <Products />
      <OrderForm />
    </div>
  );
};

export default Home;
